'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _dec3, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterBootstrap = require('react-router-bootstrap');

var _Navbar = require('react-bootstrap/lib/Navbar');

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Nav = require('react-bootstrap/lib/Nav');

var _Nav2 = _interopRequireDefault(_Nav);

var _NavItem = require('react-bootstrap/lib/NavItem');

var _NavItem2 = _interopRequireDefault(_NavItem);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _info = require('redux/modules/info');

var _auth = require('redux/modules/auth');

var _components = require('components');

var _reactRouterRedux = require('react-router-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactWorldFlags = require('react-world-flags');

var _reactWorldFlags2 = _interopRequireDefault(_reactWorldFlags);

var _reactI18next = require('react-i18next');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// var os = require("os");

var App = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        language = _ref.params.language;

    var promises = [];

    if (!(0, _info.isLoaded)(getState())) {
      promises.push(dispatch((0, _info.load)()));
    }
    if (!(0, _auth.isLoaded)(getState())) {
      promises.push(dispatch((0, _auth.load)()));
    }

    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}, { logout: _auth.logout, pushState: _reactRouterRedux.push }), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(App, _Component);

  function App() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, App);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = App.__proto__ || (0, _getPrototypeOf2.default)(App)).call.apply(_ref2, [this].concat(args))), _this), _this.handleLogout = function (event) {
      event.preventDefault();
      _this.props.logout();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(App, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!this.props.user && nextProps.user) {
        // login
        // this.props.pushState('/loginSuccess');
        this.props.pushState('/account');
      } else if (this.props.user && !nextProps.user) {
        // logout
        this.props.pushState('/');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          user = _props.user,
          t = _props.t;
      var language = this.props.params.language;

      var styles = require('./App.scss');

      var path = language === undefined ? '/' : '/'; // + language;
      return _react2.default.createElement(
        'div',
        { className: styles.app },
        _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
        _react2.default.createElement(
          _Navbar2.default,
          { fixedTop: true },
          _react2.default.createElement(
            _Navbar2.default.Header,
            null,
            _react2.default.createElement(
              _Navbar2.default.Brand,
              null,
              _react2.default.createElement(
                _reactRouter.IndexLink,
                { to: '' + path, onClick: function onClick(e) {
                    console.log("hey");
                    console.log(language);
                    // if (language !== undefined) {
                    //   this.props.pushState('/' + language);
                    // }
                  }, activeStyle: { color: '#33e0ff' } },
                _react2.default.createElement('div', { className: styles.brand }),
                _react2.default.createElement('span', null)
              )
            ),
            _react2.default.createElement(_Navbar2.default.Toggle, null)
          ),
          _react2.default.createElement(
            _Navbar2.default.Collapse,
            { eventKey: 0 },
            _react2.default.createElement(
              _Nav2.default,
              { navbar: true },
              _config2.default.is_for_personal_purpose && !user && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/login' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 5 },
                  t('content.login')
                )
              )
              // console.log('hey')
              // console.log(config.is_for_personal_purponse)
              ,
              _config2.default.is_for_personal_purpose && _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/page/1' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 6 },
                  t('content.content')
                )
              ),
              user &&
              // <p className={styles.loggedInMessage + ' navbar-text'}>Logged in as <strong>{user.email}</strong>.</p>}
              _react2.default.createElement(
                _reactRouterBootstrap.LinkContainer,
                { to: '/account' },
                _react2.default.createElement(
                  _NavItem2.default,
                  { eventKey: 6, className: 'logout-link' },
                  t('content.me')
                )
              )
            ),
            _react2.default.createElement(
              _Nav2.default,
              { navbar: true, pullRight: true },
              _react2.default.createElement(
                _NavItem2.default,
                { pullRight: true, eventKey: 6, className: 'logout-link', href: '/vi' },
                _react2.default.createElement(_reactWorldFlags2.default, { code: 'VN', height: '16' })
              ),
              user && _react2.default.createElement(
                _NavItem2.default,
                { pullRight: true, eventKey: 6, className: 'logout-link', href: '/en' },
                _react2.default.createElement(_reactWorldFlags2.default, { code: 'US', height: '16' })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.appContent },
          this.props.children
        ),
        _react2.default.createElement(_components.InfoBar, null),
        _react2.default.createElement(
          'div',
          { className: 'well text-center' },
          'Copyright\xA9 2023 H\u1ECDc H\u1ECDc H\u1ECDc.',
          _react2.default.createElement('br', null)
        )
      );
    }
  }]);
  return App;
}(_react.Component), _class2.propTypes = {
  children: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  logout: _react.PropTypes.func.isRequired,
  pushState: _react.PropTypes.func.isRequired,
  t: _react.PropTypes.func
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp2)) || _class) || _class) || _class);
exports.default = App;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.js
// module id = 1514
// module chunks = 0